import React, { Component } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'

class MySweetAlert extends Component {
  render() {
    const { show, onCancel, onConfirm, title, text, type } = this.props;
    return (
        <div>
        <SweetAlert
            show={show}
            onCancel={onCancel}
            onConfirm={onConfirm}
            closeOnClickOutside 
            showCancel
            type={type ? type : "error"}
            btnSize="sm"
            customClass="swal2"
            confirmBtnCssClass="btn btn-success swal2-confirm"
            cancelBtnCssClass="btn btn-danger swal2-cancel"
            confirmBtnText="بله, مطمئنم!"
            cancelBtnText="خیر"
            title={title}
            >
          {text ? text : "بعد از حذف، این اطلاعات به هیچ وجه قابل بازیابی نخواهد بود."}
        </SweetAlert>
        </div>
    );
  }
}
export default MySweetAlert;
